import { chains, } from ".";
import {
	isAddress,
	type Address,
	type AllValidTokens,
	type TokenSymbol,
} from "./types";


export const lookupToken = <C extends keyof typeof chains>(
	chain: C,
	item: keyof typeof chains[C]["tokens"] | TokenSymbol<C>,
	options: { warn?: boolean; } = { warn: false, },
): Address => {
	const { warn, } = options;
	const key = Object.keys(chains[chain].tokens).find(tok => tok.toLowerCase() === (item as string).toLowerCase())
	if(key) {
		const address = chains[chain].tokens[key];
		if(isAddress(address)) {
			return address;
		}
	}
	if( !warn ) {
		throw new Error(`@bracket/addressbook::lookupToken failed to find token "${item.toString()}" on chain ${chain}`);
	}
}

export const lookupTokens = <C extends keyof typeof chains>(
	chain: C,
	tokens: AllValidTokens[],
): Address[] => {
	const result = [] as Address[];
	for( const token of tokens ) {
		const address = lookupToken(chain, token);
		if( isAddress(address) ) {
			result.push(address);
		}
	}
	return result;
}

export const lookupContract = <C extends keyof typeof chains>(
	chain: C,
	item: keyof typeof chains[C]["contracts"],
	options: { warn?: boolean; } = { warn: false, },
): Address => {
	const { warn, } = options;
	// @ts-ignore ... this is working - work out later
	const address = chains[chain].contracts[item];
	if( isAddress( address ) ) {
		return address;
	}
	if( !warn ) {
		throw new Error(`@bracket/addressbook::lookupContract failed to find contract "${item.toString()}" on chain ${chain}`);
	}
}

export const lookupAddress = <C extends keyof typeof chains>(
	chain: C,
	item: keyof typeof chains[C]["addresses"],
	options: { warn?: boolean; } = { warn: false, },
): Address => {
	const { warn, } = options;
	// @ts-ignore ... this is working - work out later
	const address = chains[chain].addresses[item];
	if( isAddress( address ) ) {
		return address;
	}
	if( !warn ) {
		throw new Error(`@bracket/addressbook::lookupAddresses failed to find token "${item.toString()}" on chain ${chain}`);
	}
}
